import Aegis from '@tencent/aegis-web-sdk';

const CODE_NOT_IN_WHITE_LIST = 42001;
const CODE_NO_ROLE = 300011;

const aegis = new Aegis({
  id: process.env.VUE_APP_AEGIS_ID, // 项目ID
  reportApiSpeed: true, // 开启接口测速
  reportAssetSpeed: true, // 开启静态资源测速
  spa: true,
  hostUrl: 'https://rumt-zh.com',
  beforeRequest(data) {
    // 入参data的数据结构：{logs: {…}, logType: "log"}
    if (data.logType === 'log' && data.logs.msg.includes('onWebShow')) {
      // 拦截：日志类型为log，且内容包含onWebShow的请求
      return false;
    }
    if (data.logType === 'log' && data.logs.msg.includes('getAttribute')) {
      // 拦截：日志类型为log，且内容包含getAttribute的请求
      return false;
    }
    if (data.logType === 'log' && data.logs.msg.includes('initLottery')) {
      // 拦截：针对旧版抽奖 sdk 的样式报错
      return false;
    }
    if (data.logType === 'log' && data.logs.msg.includes('@ (:0:0)')) {
      // 拦截：无法识别的Script error. @ (:0:0)
      return false;
    }
    if (data.logType === 'log'
      && (data.logs.msg.includes('OnEnterForeground') || data.logs.msg.includes('OnEnterBackground'))) {
      // 拦截：MSDK外部脚本引发的错误
      return false;
    }
    return data;
  },
  api: {
    apiDetail: true,
    reqHeaders: ['x-request-id', 't-access-token', 't-account-type', 't-appid', 't-openid', 't-device-type'], // 记录 request header
    resHeaders: ['x-request-id', 'Content-Type', 'server'], // 记录 response header
    retCodeHandler(res, url) {
      try {
        const { ret, iRet, data, code, status } = JSON.parse(res);
        // 忽略beacon,ams的埋点上报,,msdk token接口
        let ignoreFlag = false;
        const ignoreArray = [
          '/beacon',
          'ams.game.qq.com',
          'dmplog.qq.com',
          '/getAccessTokenByMSDK',
        ];
        ignoreArray.forEach((includeValue) => {
          if (url.indexOf(includeValue)) {
            ignoreFlag = true;
          }
        });
        if (ignoreFlag === true) {
          return {
            isErr: false,
            ret,
          };
        }
        // 处理正常的code
        if (ret === 0 || iRet === 0 || code === 0 || status === 0) {
          return {
            isErr: false,
            ret: 0,
          };
        }
        let errFlag = false;
        if (![0, CODE_NO_ROLE, CODE_NOT_IN_WHITE_LIST].includes(ret)) {
          errFlag = true;
        }
        if (url.indexOf('/WPEIndex') !== -1) {
          try {
            // data为json,判断条件机的ret
            if (data.length > 0) {
              const conditionData = JSON.parse(data);
              if (ret === 0 && conditionData.ret && conditionData.ret !== 0) {
                // 条件机返回不为0也要上报
                errFlag = true;
              }
            }
          } catch (e) {
            // do nothing
            console.error(e);
          }
        }
        if (ret === 0 && data.ret && data.ret !== 0) {
          // 其他请求data中的ret不为0,也返回错误
          errFlag = true;
        }
        return {
          isErr: errFlag, // 0正常,300011拉不到角色也属于正常
          ret,
        };
      } catch (e) { }
      return {
        isErr: true,
        ret: -1, // TODO 上报无返回结果的请求
      };
    },
  },
});

export default aegis;
